import { useEffect, useState } from 'react'
import { api, getToken } from '../api'
import { Card, Button, Form, Input, InputNumber, Upload, Space, Typography, message, Spin, Row, Col } from 'antd'
import { UploadOutlined, SaveOutlined, PlusOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

export default function Configuracion() {
  const [config, setConfig] = useState({})
  const [cargando, setCargando] = useState(true)
  const [guardando, setGuardando] = useState(false)
  const [subiendo, setSubiendo] = useState(false)
  const [form] = Form.useForm()
  const [municipios, setMunicipios] = useState([])
  const [formMun] = Form.useForm()

  useEffect(() => { cargar() }, [])

  const cargar = async () => {
    try {
      const data = await api('/config')
      setConfig(data)
      form.setFieldsValue({ nombre_app: data.nombre_app || 'Cox Agro' })
      setMunicipios(await api('/municipios'))
    } catch (err) {
      console.error('Error cargando config:', err)
    }
    setCargando(false)
  }

  const guardarNombre = async (values) => {
    setGuardando(true)
    try {
      await api('/config', { method: 'PUT', body: JSON.stringify({ clave: 'nombre_app', valor: values.nombre_app }) })
      message.success('Nombre actualizado')
      cargar()
    } catch (err) {
      message.error('Error guardando')
    }
    setGuardando(false)
  }

  // Tahúlla por pueblo: con ella se pasan a tahúllas las hectáreas de SIGPAC
  const guardarMunicipio = async (datos) => {
    try {
      await api('/municipios', { method: 'POST', body: JSON.stringify(datos) })
      message.success(`Tahúlla de ${datos.municipio.toUpperCase()} guardada`)
      formMun.resetFields()
      setMunicipios(await api('/municipios'))
    } catch (err) {
      message.error(err.message)
    }
  }

  const subirLogo = async (file) => {
    setSubiendo(true)
    try {
      const formData = new FormData()
      formData.append('logo', file)
      const token = getToken()
      const res = await fetch('/api/config/logo', {
        method: 'POST',
        headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body: formData,
      })
      const data = await res.json()
      if (data.logo_url) {
        message.success('Logo actualizado')
        cargar()
      } else {
        message.error(data.error || 'Error subiendo logo')
      }
    } catch (err) {
      message.error('Error subiendo logo')
    }
    setSubiendo(false)
    return false
  }

  if (cargando) return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <div style={{ background: 'linear-gradient(135deg, #1B3A6B 0%, #2E5FA3 100%)', padding: '20px' }}>
        <Title level={4} style={{ color: 'white', margin: 0 }}>Configuración</Title>
      </div>
      <div style={{ textAlign: 'center', marginTop: '60px' }}><Spin size="large" /></div>
    </div>
  )

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <div style={{ background: 'linear-gradient(135deg, #1B3A6B 0%, #2E5FA3 100%)', padding: '20px' }}>
        <Title level={4} style={{ color: 'white', margin: 0 }}>Configuración</Title>
      </div>

      <div style={{ padding: '16px' }}>
        {/* Logo */}
        <Card size="small" title="Logo de la aplicación" style={{ borderRadius: '12px', marginBottom: '16px' }}>
          <div style={{ textAlign: 'center', marginBottom: '16px' }}>
            {config.logo_url ? (
              <img
                src={config.logo_url}
                alt="Logo"
                style={{ maxWidth: '200px', maxHeight: '120px', borderRadius: '8px', border: '1px solid #f0f0f0', padding: '8px' }}
              />
            ) : (
              <div style={{ width: '200px', height: '100px', background: '#f5f5f5', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto' }}>
                <Text type="secondary">Sin logo</Text>
              </div>
            )}
          </div>
          <Upload
            accept="image/jpeg,image/png,image/svg+xml,image/webp"
            beforeUpload={subirLogo}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />} loading={subiendo} block>
              {subiendo ? 'Subiendo...' : 'Subir logo'}
            </Button>
          </Upload>
          <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginTop: '8px', textAlign: 'center' }}>
            JPG, PNG, SVG o WebP. Máx. 5MB
          </Text>
        </Card>

        {/* Tahúlla por pueblo */}
        <Card size="small" title="Tahúlla por pueblo" style={{ borderRadius: '12px', marginBottom: '16px' }}>
          <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginBottom: '10px' }}>
            Metros cuadrados de la tahúlla en cada pueblo. Se usan para pasar a tahúllas las hectáreas de SIGPAC de todas sus parcelas.
          </Text>
          <Space direction="vertical" size={6} style={{ width: '100%', marginBottom: '12px' }}>
            {municipios.map(m => (
              <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Text style={{ flex: 1, fontSize: '13px' }}>{m.municipio} <Text type="secondary" style={{ fontSize: '11px' }}>({m.provincia})</Text></Text>
                <InputNumber
                  size="small"
                  min={100}
                  max={20000}
                  defaultValue={parseFloat(m.tahulla_m2)}
                  suffix="m²"
                  style={{ width: 140 }}
                  onBlur={e => {
                    const v = parseFloat(String(e.target.value).replace(',', '.'))
                    if (v && v !== parseFloat(m.tahulla_m2)) guardarMunicipio({ municipio: m.municipio, provincia: m.provincia, tahulla_m2: v })
                  }}
                />
              </div>
            ))}
          </Space>
          <Form form={formMun} layout="vertical" onFinish={guardarMunicipio}>
            <Row gutter={8}>
              <Col span={12}><Form.Item name="municipio" label="Pueblo" rules={[{ required: true, message: 'Obligatorio' }]} style={{ marginBottom: '8px' }}><Input size="small" placeholder="Ej.: Orihuela" /></Form.Item></Col>
              <Col span={12}><Form.Item name="provincia" label="Provincia" rules={[{ required: true, message: 'Obligatorio' }]} style={{ marginBottom: '8px' }}><Input size="small" placeholder="Ej.: Alicante" /></Form.Item></Col>
              <Col span={24}><Form.Item name="tahulla_m2" label="Metros de la tahúlla" rules={[{ required: true, message: 'Obligatorio' }]} style={{ marginBottom: '8px' }}><InputNumber size="small" min={100} max={20000} suffix="m²" placeholder="Ej.: 1185" style={{ width: '100%' }} /></Form.Item></Col>
            </Row>
            <Button size="small" icon={<PlusOutlined />} htmlType="submit" block>Añadir pueblo</Button>
          </Form>
          <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginTop: '8px' }}>
            Escribe el pueblo y la provincia como salen en SIGPAC. Al dar de alta una parcela de un pueblo nuevo, la aplicación te lo preguntará.
          </Text>
        </Card>

        {/* Nombre app */}
        <Card size="small" title="Nombre de la aplicación" style={{ borderRadius: '12px' }}>
          <Form form={form} layout="vertical" onFinish={guardarNombre}>
            <Form.Item label="Nombre" name="nombre_app" rules={[{ required: true }]}>
              <Input placeholder="Ej: Cox Agro, Mi Finca..." />
            </Form.Item>
            <Button type="primary" icon={<SaveOutlined />} loading={guardando} htmlType="submit" block>
              Guardar
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  )
}
